import { render, staticRenderFns } from "./GuardiansYN.vue?vue&type=template&id=f31143be"
import script from "./GuardiansYN.vue?vue&type=script&lang=js"
export * from "./GuardiansYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports